/**
 * @fileoverview Skeleton - Loading skeleton component
 *
 * Purpose: Display loading placeholders while content loads
 * Dependencies: None
 * Used by: Loading states, content placeholders, lazy loading
 *
 * Features:
 * - Pulsing animation
 * - Customizable size and shape
 * - Accessible (indicates loading state)
 * - Works for text, images, cards
 *
 * @example
 * <Skeleton className="h-12 w-12 rounded-full" />
 *
 * @example
 * // Text skeleton
 * <div className="space-y-2">
 *   <Skeleton className="h-4 w-[250px]" />
 *   <Skeleton className="h-4 w-[200px]" />
 * </div>
 */

import { cn } from "@/utils/misc";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
